import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Button } from "antd";
import { PageContainer, ProCard, } from '@ant-design/pro-components';
import 'antd/dist/reset.css';
import FormDrawer from "../../components/FormDrawer";
import { ItemsForm } from "./ItemsForm";
import { Configuration, ConfigurationParameters, ItemApi, ItemDto, PartyDto } from "../../api/najd";
import ItemsTable from "./ItemsTable";
import { API_URL } from "../../constants";
import { useAuth } from "react-oidc-context";

interface ItemsProps {
    partyInfo: PartyDto;
}
export const Items: React.FC<ItemsProps> = ({ partyInfo }) => {
    const { t } = useTranslation();
    const [editMode, setEditMode] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState<any>(null);
    const [refreshTrigger, setRefreshTrigger] = useState<boolean>(false);

    const auth = useAuth();

    const token = auth.user?.access_token;
    const configParameters: ConfigurationParameters = {
        basePath: API_URL,
        accessToken: token,
        baseOptions: {
            headers: { Authorization: 'Bearer ' + token },
        }
    };
    const configuration = new Configuration(configParameters);
    
    const itemApi = new ItemApi(configuration);

    const closeDrawer = () => {
        setDrawerOpen(false);
    };

    const handleRefresh = () => {
        setRefreshTrigger((prevState) => !prevState);
    };

    const onClickCreateNew = () => {
        // Handle create new action
        setEditMode(false);
        setSelectedRowData({unitPrice:0 ,taxRatePerUnit : 15,taxAmountPerUnit:0}); // Set the selected row data in the state
        setDrawerOpen(true);
    };

    const onClickRowEdit = (rowData: any) => {
        // Handle the row edit action
        setEditMode(true);
        setSelectedRowData(rowData); // Set the selected row data in the state
        setDrawerOpen(true);
    };

    const onClickSubmitButton = () => {
        // Handle the row edit action
        if (selectedRowData) {
            handleFormSubmit(selectedRowData);
        }
    };
    // const onSubmit = (formData: any) => {
    //     // Handle the row edit action
    //     console.log('On Submit:', formData);
    // };

    // Form Events
    const handleFormSubmit = (formData: any) => {
        // Handle form submission in the parent component
        console.log('Form Data:', formData);
        if (editMode == true) {
            itemApi.itemUpdate(formData.id, formData)
                .then(response => {
                    // Handle the API response
                    closeDrawer();
                    handleRefresh();
                })
                .catch(error => {
                    // Handle the API error
                    console.error(error);
                });
        } else {
            itemApi.itemCreate(formData)
                .then(response => {
                    // Handle the API response
                    closeDrawer();
                    handleRefresh();
                })
                .catch(error => {
                    // Handle the API error
                    console.error(error);
                });
        }
    };
    const handleFormChange = (formData: any) => {
        console.log('handleFormChange:', formData);
        setSelectedRowData(formData);
    };
    // End Form Events
    return (
        <PageContainer
            header={{
                title: t('Items'),
                ghost: true,
                breadcrumb: {
                    items: [
                        {
                            path: '/',
                            title: t("Home"),
                        },
                        {
                            path: '/',
                            title: t("Items"),
                        },
                    ],
                },
                extra: [
                    <Button key="3" type="primary" onClick={onClickCreateNew}>
                        {t("Add New")}
                    </Button>,
                ],
            }}
        // footer={[
        //     <Button key="3">خيار 14</Button>,
        //     <Button key="2" type="primary">
        //         خيار 15
        //     </Button>,
        // ]}
        >
            <ProCard
            // style={{
            //     height: '100vh',
            //     minHeight: 800,
            // }}
            >
                <ItemsTable
                    partyInfo={partyInfo}
                    onClickRowEdit={onClickRowEdit}
                    refreshTrigger={refreshTrigger}
                    setRefreshTrigger={setRefreshTrigger}
                />
                <FormDrawer open={drawerOpen}
                    onClose={closeDrawer}
                    formData={selectedRowData}
                    title={((editMode) ? t("Edit") : t("Create new"))}
                    onSubmit={onClickSubmitButton}>
                    <ItemsForm
                        editMode={editMode}
                        onClose={closeDrawer}
                        formData={selectedRowData}
                        onSubmit={handleFormSubmit}
                        onChange={handleFormChange} />
                </FormDrawer>
            </ProCard>
        </PageContainer>
    );
};
